import { memo } from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  floatingButton: {
    position: "fixed",
    bottom: "2rem",
    right: "2rem",
    width: "4rem",
    height: "4rem",
    backgroundColor: "#8FC73E",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    transition: "all 0.3s ease",
    zIndex: 1000,
    border: "none",
    color: "white",
    fontSize: "4rem",
    "&:hover": {
      transform: "scale(1.1)",
    },
    "&:active": {
      transform: "scale(0.95)",
    },
  },
});

interface Props {
  onClick: () => void;
}

const CreateQuestionButton = ({ onClick }: Props) => {
  const classes = useStyles();
  return (
    <button
      className={classes.floatingButton}
      title="Create Question"
      type="button"
      onClick={onClick}
    >
      +
    </button>
  );
};

export default memo(CreateQuestionButton);
